import {defaultTips} from 'quickstart/hooks/useGlobalSearchConfig'
import {MouseEvent, RefObject, useCallback, useRef} from 'react'
import {useField} from 'react-final-form'
import * as A from '../admin'
import {SearchBlockGlobalConfig} from './meta'

export const Admin = () => (
  <p>
    Search is configured globally in <A.NavOut tab="Design" subtab="features" />
    .
  </p>
)

const SearchTipsHint = ({
  name,
  inputRef,
}: {
  name: string
  inputRef: RefObject<HTMLTextAreaElement | null>
}) => {
  const {
    input: {onChange},
  } = useField(name)
  const populateDefault = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault()
      // Tell Final Form about the change...
      onChange(defaultTips)
      // ...and change immediately in the textarea, so that we can focus, select
      // all, and scroll to the top. If we only set via Final Form, then we
      // can't immediately select all. If we only set value directly, then Final
      // Form will override.
      const input = inputRef.current
      if (input) {
        input.value = defaultTips
        input.focus()
        input.select()
        input.scrollTop = 0
      }
    },
    [onChange, inputRef],
  )
  return (
    <span>
      Leave blank for default, or{' '}
      <a href="#" onClick={populateDefault}>
        click here to insert the default for customization.
      </a>
    </span>
  )
}

export const GlobalAdmin: A.Admin<SearchBlockGlobalConfig> = () => {
  const metaTypeOptions = A.useMetaTypeOptions()
  const tipsRef = useRef<HTMLTextAreaElement>(null)
  return (
    <A.Group>
      <A.Checklist
        label="Meta-types for metadata search"
        name="metadataMetaTypes"
        options={metaTypeOptions}
      />
      <A.YesNo label="Search tables of contents?" name="tocDepth" />
      <A.YesNo label="Search full text?" name="fulltextDepth" />
      <A.YesNo label="Show page thumbnails?" name="showPageThumbnails" />
      {/* TODO: MarkdownEditor, need replacement for ref-based insertion */}
      <A.Textarea
        label="Custom search tips Markdown:"
        name="fields.terms.customTips"
        hint={
          <SearchTipsHint name="fields.terms.customTips" inputRef={tipsRef} />
        }
        ref={tipsRef}
      />
      <A.Textarea
        label="Custom search config JSON"
        name="customSearchConfigJson"
      />
    </A.Group>
  )
}
